<template>
  <section>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Terminar"
      next-button-text="Siguiente"
      back-button-text="Previo"
      @on-complete="Finalizar"
    >
      <tab-content
        title="Constancia de Situación Fiscal"
        :before-change="ValidStep1"
      >
        <!-- documentos vinculados -->
        <b-row v-show="storedFiles.length > 0 && flgUpload==false">
          <b-col
            md="12"
            class="mb-2"
          >
            <h3 class="mb-1">
              Documentos vinculados
            </h3>
            <h5 class="text-primary">
              El documento de <b>"Constancia de Situación Fiscal"</b>, actual sera utilizado para la emision de facturas.
            </h5>
          </b-col>
          <!-- lista de archivos vinculados -->
          <b-col
            md="12"
            class="mb-2"
          >
            <b-list-group>
              <b-list-group-item
                v-for="(file, index) in storedFiles"
                :key="index"
                class="d-flex border border-success cursor-pointer"
                @click="downloadFile(file)"
              >
                <span class="mr-1">
                  <feather-icon
                    icon="FileTextIcon"
                    size="16"
                  />
                </span>
                <span><b>{{ file.rutaDoc+file.extBase }}</b></span>
              </b-list-group-item>
            </b-list-group>
          </b-col>
          <!-- opcion de volver a subir -->
          <b-col md="12">
            <b-card-body class="invoice-padding pt-0 text-center">
              <span class="font-weight-bold">¿Requiere subir de nuevo la constancia? <b-badge
                variant="light-primary"
                style="cursor: pointer;"
                @click="flgUpload = true"
              > SI </b-badge> </span>
            </b-card-body>
            <hr class="invoice-spacing">
          </b-col>
        </b-row>
        <!-- Modulos para subir documentos -->
        <b-row v-show="flgUpload">
          <b-col
            md="12"
            class="mb-2"
          >
            <h3 class="mb-1">
              Atención
            </h3>
            <h5 class="text-primary">
              Hola, por indicaciones del SAT se requiere subir su "Constancia de Situación Fiscal", para la emision de facturas, <b>formatos admitidos [pdf, jpg, png ]</b>
            </h5>
          </b-col>
          <b-col md="12">
            <b-form
              class="p-2 needs-validation"
              novalidate
              @submit.prevent
            >
              <!-- step 1 -->
              <!-- Upload file -->
              <b-form-group
                :label="'Constancia de Situación Fiscal '+((storedFiles.length > 0) ? ' Actualizada' : '')"
                label-for="invoice-balance"
              >
                <b-form-file
                  v-model="filepayment"
                  :state="Boolean(filepayment)"
                  placeholder="Seleccione su documento en formato valido"
                  accept=".jpg, .pdf, .png, .jpeg"
                >
                  <template
                    slot="file-name"
                    slot-scope="{ names }"
                  >
                    <b-badge variant="primary">
                      {{ names[0] }}
                    </b-badge>
                    <b-badge
                      v-if="names.length > 1"
                      variant="dark"
                      class="ml-1"
                    >
                      + {{ names.length - 1 }} More files
                    </b-badge>
                  </template>
                </b-form-file>
              </b-form-group>
            </b-form>

          </b-col>
          <!-- botones de subir archivo -->
          <b-col md="12">
            <!-- btn upload -->
            <b-form-group>
              <div class="text-center">
                <b-button
                  v-show="checkProcess.storagefile== false"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-warning"
                  class="mr-2"
                  size="sm"
                  @click="checkSalida()"
                >
                  [ ESC ] Salir
                </b-button>
                <b-button
                  v-show="checkProcess.storagefile== false"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="relief-primary"
                  size="sm"
                  @click="uploadfile()"
                >
                  <feather-icon
                    icon="UploadCloudIcon"
                    class="mr-50"
                  />
                  <b-spinner
                    v-show="loader.upload"
                    variant="success"
                    class="mr-1"
                    small
                  />
                  {{ (loader.upload) ? 'Trabajando...': 'Subir documento' }}
                </b-button>
              </div>
            </b-form-group>
          </b-col>
          <!-- leyenda complete file -->
          <b-col
            v-show="checkProcess.storagefile"
            md="12"
          >
            <b-alert
              show
              variant="primary"
            >
              <div class="alert-body">
                <feather-icon
                  class="mr-25"
                  icon="CheckCircleIcon"
                />
                <span class="ml-25">tu archivo ya fue almacenado, puede continuar.</span>
              </div>
            </b-alert>
          </b-col>
        </b-row>
      </tab-content>
      <tab-content
        title="Completar Información"
      >
        <b-overlay
          :show="loader.factura"
          opacity="0.50"
          rounded="sm"
        >
          <validation-observer ref="refDatosFacturacion">
            <b-form v-if="datos">
              <b-row>
                <!-- Alias -->
                <b-col md="3">
                  <validation-provider
                    #default="{ errors }"
                    name="Alias"
                    rules="required"
                  >
                    <b-form-group
                      label="Alias"
                      label-for="helperInput"
                      description="Nombre que se le dará a tu registro para identificarlo más facilmente"
                    >
                      <b-skeleton-wrapper :loading="loader.fetchData">
                        <!-- Loader -->
                        <template #loading>
                          <b-skeleton
                            type="button"
                            width="100%"
                          />
                        </template>
                        <b-form-input
                          id="register-username"
                          v-model="datos.alias"
                          name="register-username"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-skeleton-wrapper>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- Razón social -->
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Razon"
                    rules="required"
                  >
                    <b-form-group
                      label="Razón social"
                      label-for="helperInput"
                      description="Razón social a facturar"
                    >
                      <b-skeleton-wrapper :loading="loader.fetchData">
                        <!-- Loader -->
                        <template #loading>
                          <b-skeleton
                            type="button"
                            width="100%"
                          />
                        </template>
                        <b-form-input
                          id="register-razon"
                          v-model="datos.razon"
                          name="register-razon"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-skeleton-wrapper>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- RFC -->
                <b-col md="3">
                  <validation-provider
                    #default="{ errors }"
                    name="Rfc"
                    rules="required|max:15"
                  >
                    <b-form-group
                      label="RFC"
                      label-for="helperInput"
                      description="Registro Federal de Contribuyentes"
                    >
                      <b-skeleton-wrapper :loading="loader.fetchData">
                        <!-- Loader -->
                        <template #loading>
                          <b-skeleton
                            type="button"
                            width="100%"
                          />
                        </template>
                        <b-form-input
                          id="register-username"
                          v-model="datos.rfc"
                          name="register-username"
                          onkeyup="javascript:this.value=this.value.toUpperCase();"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-skeleton-wrapper>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
              <titleSection
                :title="'Dirección'"
                :subtitle="'Escriba los datos que a continuación se le piden'"
                icon="InfoIcon"
              />
              <b-row class="mt-1">
                <!-- calle  -->
                <b-col
                  md="6"
                  lg="6"
                  sm="12"
                >
                  <b-form-group
                    label="Calle"
                    label-for="calle"
                  >
                    <b-skeleton-wrapper :loading="loader.fetchData">
                      <!-- Loader -->
                      <template #loading>
                        <b-skeleton
                          type="button"
                          width="100%"
                        />
                      </template>
                      <b-form-input
                        id="calle"
                        v-model="datos.calle"
                      />
                    </b-skeleton-wrapper>
                  </b-form-group>
                </b-col>

                <!-- numero  -->
                <b-col
                  md="6"
                  lg="2"
                  sm="12"
                >
                  <b-form-group
                    label="Número"
                    label-for="numero"
                  >
                    <b-skeleton-wrapper :loading="loader.fetchData">
                      <!-- Loader -->
                      <template #loading>
                        <b-skeleton
                          type="button"
                          width="100%"
                        />
                      </template>
                      <b-form-input
                        id="numero"
                        v-model="datos.numero"
                      />
                    </b-skeleton-wrapper>
                  </b-form-group>
                </b-col>

                <!-- interior  -->
                <b-col
                  md="6"
                  lg="2"
                  sm="12"
                >
                  <b-form-group
                    label="Interior"
                    label-for="interior"
                  >
                    <b-skeleton-wrapper :loading="loader.fetchData">
                      <!-- Loader -->
                      <template #loading>
                        <b-skeleton
                          type="button"
                          width="100%"
                        />
                      </template>
                      <b-form-input
                        id="interior"
                        v-model="datos.interior"
                      />
                    </b-skeleton-wrapper>
                  </b-form-group>
                </b-col>
                <!-- código postal  -->
                <b-col
                  md="6"
                  lg="2"
                  sm="12"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="código postal"
                    rules="digits:5|required"
                  >
                    <b-form-group
                      label="Código postal"
                      label-for="cp"
                    >
                      <b-skeleton-wrapper :loading="loader.fetchData">
                        <!-- Loader -->
                        <template #loading>
                          <b-skeleton
                            type="button"
                            width="100%"
                          />
                        </template>
                        <b-form-input
                          id="cp"
                          v-model="datos.cp"
                          :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-skeleton-wrapper>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
              <b-row>
                <!-- colonia  -->
                <b-col
                  md="6"
                  lg="6"
                  sm="12"
                >
                  <b-form-group
                    label="Colonia"
                    label-for="colonia"
                  >
                    <b-skeleton-wrapper :loading="loader.fetchData">
                      <!-- Loader -->
                      <template #loading>
                        <b-skeleton
                          type="button"
                          width="100%"
                        />
                      </template>
                      <b-form-input
                        id="colonia"
                        v-model="datos.colonia"
                      />
                    </b-skeleton-wrapper>
                  </b-form-group>
                </b-col>
                <!-- municipio -->
                <b-col
                  md="6"
                  lg="6"
                  sm="12"
                >
                  <b-form-group
                    label="Municipio [ escriba y seleccione ]"
                    label-for="municipio"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="municipio"
                      rules="required"
                    >
                      <b-skeleton-wrapper :loading="loader.fetchData">
                        <!-- Loader -->
                        <template #loading>
                          <b-skeleton
                            type="button"
                            width="100%"
                          />
                        </template>
                        <v-select
                          v-model="datos.municipio"
                          placeholder="Búsque su municipio y seleccionelo"
                          label="nombre"
                          :filterable="false"
                          :options="municipios"
                          :clearable="false"
                          @search="onSearch"
                        >
                          <!-- CUANDO NO HAY OPCIONES -->
                          <template #no-options>
                            Teclea al menos 4 letras de tu municipio y seleccionelo
                          </template>
                          <!-- COMO SE VEN LAS OPCIONES -->
                          <template #option="{ nombre }">
                            <span>{{ nombre }}</span>
                          </template>                    <!-- COMO SE VE LA OPCIÓN SELECCIONADA -->
                          <template #selected-option="{ nombre }">
                            <div>
                              <b class="text-primary">{{ nombre }}</b>
                            </div>
                          </template>
                        </v-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-skeleton-wrapper>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <!-- referencia 1  -->
                <b-col
                  md="6"
                  lg="6"
                  sm="12"
                >
                  <b-form-group
                    label="Referencia 1"
                    label-for="ref1"
                  >
                    <b-skeleton-wrapper :loading="loader.fetchData">
                      <!-- Loader -->
                      <template #loading>
                        <b-skeleton
                          type="button"
                          width="100%"
                        />
                      </template>
                      <b-form-input
                        id="ref1"
                        v-model="datos.ref1"
                      />
                    </b-skeleton-wrapper>
                  </b-form-group>
                </b-col>

                <!-- referencia 2  -->
                <b-col
                  md="6"
                  lg="6"
                  sm="12"
                >
                  <b-form-group
                    label="Referencia 2"
                    label-for="ref1"
                  >
                    <b-skeleton-wrapper :loading="loader.fetchData">
                      <!-- Loader -->
                      <template #loading>
                        <b-skeleton
                          type="button"
                          width="100%"
                        />
                      </template>
                      <b-form-input
                        id="ref2"
                        v-model="datos.ref2"
                      />
                    </b-skeleton-wrapper>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
            <hr class="invoice-spacing">
            <!-- Botones de cancelación y guardado -->
            <div
              v-if="!loader.fetchData"
              class="text-center mt-2 mb-2"
            >
              <!-- Save changes -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="relief-primary"
                @click.prevent="validationForm"
              >
                Guardar cambios
              </b-button>
            </div>
          </validation-observer>
        </b-overlay>
      </tab-content>
    </form-wizard>
  </section>
</template>

<script>
import {
  BOverlay,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormInput,
  BSkeletonWrapper,
  BSkeleton,
  BFormFile,
  BSpinner,
  BAlert,
  BBadge,
  BListGroup,
  BListGroupItem,
  BCardBody,
  // BContainer,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { required } from '@validations'
import { isObject, isEmptyObject } from '@core/utils/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref, computed, onMounted } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import titleSection from '@/views/components/title-section.vue'
import vSelect from 'vue-select'
import { getData } from '@core/utils/http/general'
import { datoFacturaInfo } from '@/views/campus/cuenta/components/edicion/useFacturacion'

export default {
  components: {
    titleSection,
    BOverlay,
    BForm,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    ValidationObserver,
    ValidationProvider,
    vSelect,
    BSkeletonWrapper,
    BSkeleton,
    FormWizard,
    TabContent,
    BFormFile,
    BSpinner,
    BAlert,
    BBadge,
    BListGroup,
    BListGroupItem,
    BCardBody,
    // BContainer,
  },
  directives: {
    Ripple,
  },
  props: {
    id: {
      type: [Number, null],
      default: null,
    },
    externalUser: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    // values for new file
    const checkProcess = ref({
      storagefile: false, step1: false, step2: false,
    })
    const flgUpload = ref(true)
    const filepayment = ref(null)
    const filesavedId = ref(null)
    const refDatosFacturacion = ref(null)
    // Si no tiene valor, devuelve un objeto vacío
    const userRole = computed(() => store.state.cuenta.rolSelected || {})
    const datos = ref({})
    const storedFiles = ref([])
    const loader = ref({
      upload: false, factura: false, fetchData: false,
    })
    const municipios = ref([])

    /**
     * configurador de directorio
     */
    const uploadconfig = computed(() => {
      let directorio = ''
      // ask if exist session
      if (isEmptyObject(store.state.cuenta.session)) {
        // es uso publico y va por external
        directorio = `alumnos/${props.externalUser.value}/dfacturacion`
      } else if (!isEmptyObject(store.state.cuenta.session)) {
        // lo estan revisando desde una cuenta [alumno / SE]
        if (!isEmptyObject(props.externalUser)) {
          // alguien manipula el registro SE
          directorio = `alumnos/${props.externalUser.value}/dfacturacion`
        } else {
          // es una session de cuenta
          directorio = `alumnos/${store.state.cuenta.session.persona}/dfacturacion`
        }
      }
      const dataReturn = {
        ref: `/${directorio}`, cat: '9', repo: 0, struct: '3',
      }
      return dataReturn
    })

    const getValuesToSend = computed(() => {
      const {
        id_fact,
        alias,
        razon,
        rfc,
        calle,
        numero,
        interior,
        cp,
        colonia,
        ref1,
        ref2,
        id_direccion,
        municipio,
      } = datos.value

      const toUpdate = {
        alias, razon, rfc, calle, numero, interior, cp, colonia, municipio, ref1, ref2, id_fact, id_direccion,
      }

      const dataReturn = {
        task: 'wsfactura', action: 4, datos: JSON.stringify(toUpdate), const_sf: null,
      }

      if (props.id && props.id !== null) {
        // viene de props quiere decir desde [pre-registro o solicitud]
        dataReturn.id = props.id
        if (isObject(props.externalUser) && !isEmptyObject(props.externalUser) && props.externalUser.value && props.externalUser.tipo) {
          // action 22 es upd registro
          toUpdate[props.externalUser.tipo] = props.externalUser.value
          // toUpdate.persona = props.externalUser.value
          dataReturn.action = 22
          dataReturn.task = 'wsinscripcion'
          dataReturn.datos = JSON.stringify(toUpdate)
        }
      } else {
        dataReturn.action = 3
        if (isObject(props.externalUser) && !isEmptyObject(props.externalUser) && props.externalUser.value && props.externalUser.tipo) {
          // action 21 es nuevo registro
          toUpdate[props.externalUser.tipo] = props.externalUser.value
          dataReturn.action = 21
          dataReturn.task = 'wsinscripcion'
          dataReturn.datos = JSON.stringify(toUpdate)
        }
      }
      // siempre mandar el rol
      toUpdate.rol = (!isEmptyObject(store.state.cuenta)) ? store.state.cuenta.rolSelected.id : 0

      return dataReturn
    })

    // * Save data
    /**
     * * saveChanges
     * ! ESTA FUNCION GUARDA Y ACTUALIZA
     * MANEJA VINCULACION DE ARCHIVO
     */
    const saveChanges = () => {
      // asigno de nuevo el valor del archivo por cualquier cosa
      // Reviso en UPD
      if (filesavedId.value != null) {
        getValuesToSend.value.const_sf = filesavedId.value.id
      }

      loader.value.factura = true
      store.dispatch('cuenta/postDatosFact', getValuesToSend.value)
        .then(response => {
          loader.value.factura = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Solicitud exitosa',
              text: response.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          },
          { timeout: 8000 })
          loader.value.factura = false
          checkProcess.value.step2 = true
          emit('reload-data')
        }, error => {
          // loader.value.factura = false
          loader.value.factura = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Agregar datos de facturacion]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    // * Validate form
    const validationForm = () => {
      refDatosFacturacion.value.validate().then(success => {
        if (success) saveChanges()
      })
    }

    // * Buscador de municipios
    const onSearch = (search, loading) => {
      if (search.length <= 3) return false // SEARCH IT'S EMPTY OR LESS THAN 4 LETTERS

      loading(true)
      getData({ action: 25, search })
        .then(response => {
          loading(false)
          if (response.status === 200 && response.data.status === 200) {
            municipios.value = response.data.data
            return true
          }
          municipios.value = []
          toast({
            component: ToastificationContent,
            props: {
              title: 'No pudimos encontrar resultados',
              text: response.data.message,
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 8000 })
          return false
        })
        .catch(err => {
          loading(false)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [municipio]',
              text: err,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
      return true
    }

    const checkSalida = () => {
      // GUARDO UN ARCHIVO Y SE QUIERE SALIR
      if (checkProcess.value.storagefile === true && checkProcess.value.step1 === true) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'Se require que termine el proceso que inicio',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      } else {
        emit('hide-form')
      }
    }

    /**
     * almacena la constancia de situacion fiscal en delivery
     * api from mario
     */
    const uploadfile = () => {
      if (filepayment.value != null) {
        loader.value.upload = true
        uploadconfig.value.file = filepayment.value
        store.dispatch('cuenta/handleFile', uploadconfig.value)
          .then(response => {
            let msn = ''
            // if (response.status === 200) {
            filesavedId.value = (response.data.ids[0]) ? response.data.ids[0] : {}
            if (Object.keys(filesavedId).length === 0) {
              msn = 'Algo no salio bien, vuelva a intentar'
            } else {
              msn = 'Comprobante almacenado!'
              getValuesToSend.value.const_sf = filesavedId.value.id
              checkProcess.value.storagefile = true
              checkProcess.value.step1 = true
            }
            toast({
              component: ToastificationContent,
              props: {
                // title: 'Atención',
                text: msn,
                icon: response.icon,
                variant: response.label,
              },
            },
            { timeout: 8000 })
            loader.value.upload = false
          }, error => {
            loader.value.upload = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Atención',
                text: error,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          })
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'Seleccione un archivo para subir',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 8000 })
      }
    }

    //* Download files
    const downloadFile = file => {
      window.open(`${process.env.VUE_APP_DELIVERY_DOWNLOAD}${file.rutaDoc}${file.extBase}`, '_blank')
    }

    /**
     * revisar si subieron
     * el archivo
     */
    const ValidStep1 = () => new Promise((resolve, reject) => {
      if (checkProcess.value.step1 === true || storedFiles.value.length > 0) {
        resolve(true)
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'Hola, aun no sube la Constancia de Situación Fiscal',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
        reject()
      }
    })

    const Finalizar = () => {
      if (checkProcess.value.step1 === true && checkProcess.value.step2 === true) {
        emit('reload-data')
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'Hola, aun no guarda la información',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
      }
    }

    // * Precargamos datos a editar
    onMounted(() => {
      if (!Number.isNaN(props.id) && props.id !== null && props.id) {
        loader.value.fetchData = true
        datoFacturaInfo(props.id).then(response => {
          // las flags pasaran a ser true por que solo esta editando
          checkProcess.value.step1 = true
          checkProcess.value.step2 = true
          datos.value = response.info
          storedFiles.value = response.files
          // si tiene documentos ya vinculados se apaga el modulo
          if (response.files.length > 0) {
            flgUpload.value = false
          }
          loader.value.fetchData = false
        }, error => {
          loader.value.fetchData = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 10000 })
        })
      }
    })

    return {
      refDatosFacturacion,
      getValuesToSend,
      validationForm,
      required,
      municipios,
      onSearch,
      // data
      userRole,
      // fuctions
      ValidStep1,
      Finalizar,
      uploadfile,
      downloadFile,
      checkSalida,
      // values
      filepayment,
      filesavedId,
      storedFiles,
      datos,
      // flags
      checkProcess,
      loader,
      flgUpload,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
